import React, { useEffect, useState } from "react";

import { Avatar, Grid, Stack, TextField, Typography } from "@mui/material";

import KRAStyles from "../pages/Styles/KRAScreen.module.scss";

interface Props {
  aadhaarData: any;
  aadaarFetched: any;
}

export default function KRAScreen({ aadhaarData, aadaarFetched }: Props) {
  const [fetechedDetails, setfetechedDetails] = useState(true);

  // console.log("aadhaarData", aadhaarData);

  return (
    <>
      {fetechedDetails ? (
        <Stack alignItems={"center"} height={"max-content"}>
          <p className={KRAStyles.header}>Fetched KRA Details</p>
          <div className={KRAStyles.container}>
            <Grid
              container
              rowSpacing={3}
              columnSpacing={{ xs: 1, sm: 2, md: 5 }}
            >
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  id="outlined-basic"
                  label="Name As per PAN"
                  variant="outlined"
                  value={aadhaarData?.pan_details?.name}
                  // value={"hhhhhhhh"}
                  focused
                  sx={{
                    input: {
                      color: "#344054",
                      fontSize: "14px",
                      borderColor: "red",
                    },
                    ".MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                      {
                        borderColor: "#c7c1c1e8",
                      },
                    "& label.Mui-focused": {
                      color: "black",
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  id="outlined-basic"
                  label="Father Name"
                  variant="outlined"
                  value={aadhaarData?.pan_details?.father_name}
                  focused
                  //value={"hhhhhhhh"}
                  sx={{
                    input: {
                      color: "#344054",
                      fontSize: "14px",
                      borderColor: "red",
                    },
                    ".MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                      {
                        borderColor: "#c7c1c1e8",
                      },
                    "& label.Mui-focused": {
                      color: "black",
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  id="outlined-basic"
                  label="Nationality"
                  variant="outlined"
                  value={aadhaarData?.pan_details?.nationality}
                  focused
                  //value={"hhhhhhhh"}
                  sx={{
                    input: {
                      color: "#344054",
                      fontSize: "14px",
                      borderColor: "red",
                    },
                    ".MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                      {
                        borderColor: "#c7c1c1e8",
                      },
                    "& label.Mui-focused": {
                      color: "black",
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  id="outlined-basic"
                  label="Date of Birth"
                  variant="outlined"
                  value={aadhaarData?.pan_details?.dob}
                  focused
                  // value={"hhhhhhhh"}
                  sx={{
                    input: {
                      color: "#344054",
                      fontSize: "14px",
                      borderColor: "red",
                    },
                    ".MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                      {
                        borderColor: "#c7c1c1e8",
                      },
                    "& label.Mui-focused": {
                      color: "black",
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  id="outlined-basic"
                  label="Gender"
                  variant="outlined"
                  value={aadhaarData?.pan_details?.gender}
                  focused
                  //value={"hhhhhhhh"}
                  sx={{
                    input: {
                      color: "#344054",
                      fontSize: "14px",
                      borderColor: "red",
                    },
                    ".MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                      {
                        borderColor: "#c7c1c1e8",
                      },
                    "& label.Mui-focused": {
                      color: "black",
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={4} justifyContent={"center"} margin={"auto"}>
                <TextField
                  fullWidth
                  id="outlined-basic"
                  label="Email"
                  variant="outlined"
                  value={aadhaarData?.pan_details?.email_address?.toLowerCase()}
                  focused
                  //value={"hhhhhhhh"}
                  sx={{
                    input: {
                      color: "#344054",
                      fontSize: "14px",
                      borderColor: "red",
                    },
                    ".MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                      {
                        borderColor: "#c7c1c1e8",
                      },
                    "& label.Mui-focused": {
                      color: "black",
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={4} justifyContent={"center"} margin={"auto"}>
                <TextField
                  fullWidth
                  id="outlined-basic"
                  label="Email"
                  variant="outlined"
                  value={aadhaarData?.pan_details?.mobile_number}
                  focused
                  //value={"hhhhhhhh"}
                  sx={{
                    input: {
                      color: "#344054",
                      fontSize: "14px",
                      borderColor: "red",
                    },
                    ".MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                      {
                        borderColor: "#c7c1c1e8",
                      },
                    "& label.Mui-focused": {
                      color: "black",
                    },
                  }}
                />
              </Grid>
              {aadhaarData?.pan_details?.income !== "" && (
                <Grid item xs={12} sm={4} justifyContent={"center"} margin={"auto"}>
                  <TextField
                    fullWidth
                    id="outlined-basic"
                    label="Income"
                    variant="outlined"
                    value={aadhaarData?.pan_details?.income}
                    focused
                    //value={"hhhhhhhh"}
                    sx={{
                      input: {
                        color: "#344054",
                        fontSize: "14px",
                        borderColor: "red",
                      },
                      ".MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                        {
                          borderColor: "#c7c1c1e8",
                        },
                      "& label.Mui-focused": {
                        color: "black",
                      },
                    }}
                  />
                </Grid>
              )}
              {aadhaarData?.pan_details?.occupation !== "" && (
                <Grid item xs={12} sm={4} justifyContent={"center"} margin={"auto"}>
                  <TextField
                    fullWidth
                    id="outlined-basic"
                    label="Occupation"
                    variant="outlined"
                    value={aadhaarData?.pan_details?.occupation}
                    focused
                    //value={"hhhhhhhh"}
                    sx={{
                      input: {
                        color: "#344054",
                        fontSize: "14px",
                        borderColor: "red",
                      },
                      ".MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                        {
                          borderColor: "#c7c1c1e8",
                        },
                      "& label.Mui-focused": {
                        color: "black",
                      },
                    }}
                  />
                </Grid>
              )}

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  id="outlined-basic"
                  label="Permanent Address"
                  variant="outlined"
                  value={`${aadhaarData?.pan_details?.permanent_address1} ${aadhaarData?.pan_details?.permanent_address2} ${aadhaarData?.pan_details?.permanent_address3}, ${aadhaarData?.pan_details?.permanent_city} , ${aadhaarData?.pan_details?.permanent_country} , ${aadhaarData?.pan_details?.permanent_pincode}`}
                  focused
                  // value={"hhhhhhhh"}
                  sx={{
                    input: {
                      color: "#344054",
                      fontSize: "14px",
                      borderColor: "red",
                    },
                    ".MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                      {
                        borderColor: "#c7c1c1e8",
                      },
                    "& label.Mui-focused": {
                      color: "black",
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  id="outlined-basic"
                  label="Correspondence Address"
                  variant="outlined"
                  value={`${aadhaarData?.pan_details?.correspondence_address1} ${aadhaarData?.pan_details?.correspondence_address2} ${aadhaarData?.pan_details?.correspondence_address3}, ${aadhaarData?.pan_details?.correspondence_city} , ${aadhaarData?.pan_details?.correspondence_state} , ${aadhaarData?.pan_details?.correspondence_country} , ${aadhaarData?.pan_details?.correspondence_pincode}`}
                  focused
                  // value={"hhhhhhhh"}
                  sx={{
                    input: {
                      color: "#344054",
                      fontSize: "14px",
                      borderColor: "red",
                    },
                    ".MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                      {
                        borderColor: "#c7c1c1e8",
                      },
                    "& label.Mui-focused": {
                      color: "black",
                    },
                  }}
                />
              </Grid>
            </Grid>
          </div>
        </Stack>
      ) : (
        <Stack>
          <Typography>No Details Fetched</Typography>
        </Stack>
      )}
    </>
  );
}
